import { useStaticQuery, graphql } from "gatsby"

export const useMicroCopySv = () => {
  const { allContentfulMikroTeksti } = useStaticQuery(
    graphql`
      query microCopySv {
        allContentfulMikroTeksti (filter: { node_locale: { eq: "sv" } }) {
          edges {
            node {
              key
              value {
                value
              }
            }
          }
        }
      }
    `
  )
  return allContentfulMikroTeksti.edges
}
